import { useRef, useSyncExternalStore } from 'react'
import { useSelector } from 'react-redux'
import { getRelogin, subscribeRelogin } from 'ts-utils/session'
import { parseHtmlIntl } from 'ts-utils'
import { Backdrop, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import styled from 'styled-components'
import oc from 'open-color'

const useStyles = makeStyles(theme => ({
    backdrop: (props) => {
        const { background } = props

        let styles = {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: theme.zIndex.drawer + 1000000,
            color: '#fff'
        }

        if (background) {
            styles = {
                ...styles,
                background
            }
        }
        
        return styles
    },
    // 조용한 표시: 화면은 막지만(다른 것이 눌리지 않게) 아무것도 보여주지 않는다
    // 금방 끝나는 일(1문 1답에서 숨김 문항 지나가기)에 회색 화면과 문구가 번쩍였다 사라지는 것을 없앤다
    // 기다리는 중이라는 표시는 문항 자리의 자리 표시(component/Survey/Live/OneSkeleton)가 맡는다
    quiet: {
        backgroundColor: 'transparent',
        '& > *': {
            display: 'none'
        }
    },
    typography: {
        [theme.breakpoints.down('xs')]: {
            fontSize: 16
        }
    }
}))

const TextStyled = styled.div`
    margin-top: 15px;
    text-align: center;
    text-shadow: 1px 1px ${oc.gray[7]};
    color: ${oc.gray[1]};
`

export const Progress = styled.progress`
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    box-sizing: border-box;
    border: none;
    border-radius: 50%;
    padding: 0.25em;
    width: 2.5em;
    height: 2.5em;
    color: white;
    background-color: transparent;
    font-size: 16px;
    overflow: hidden;
    
    &::-webkit-progress-bar {
        background-color: transparent;
    }

    /* Indeterminate */
    &:indeterminate {
        -webkit-mask-image: linear-gradient(transparent 50%, black 50%), linear-gradient(to right, transparent 50%, black 50%);
        mask-image: linear-gradient(transparent 50%, black 50%), linear-gradient(to right, transparent 50%, black 50%);
        animation: pure-material-progress-circular 6s infinite cubic-bezier(0.3, 0.6, 1, 1);
    }

    :-ms-lang(x), &:indeterminate {
        animation: none;
    }

    &:indeterminate::before,
    &:indeterminate::-webkit-progress-value {
        content: "";
        display: block;
        box-sizing: border-box;
        margin-bottom: 0.25em;
        border: solid 0.16em transparent;
        border-color: currentColor;
        border-radius: 50%;
        width: 100% !important;
        height: 100%;
        background-color: transparent;
        animation: pure-material-progress-circular-pseudo 0.75s infinite linear alternate;
    }

    &:indeterminate::-moz-progress-bar {
        box-sizing: border-box;
        border: solid 0.16em transparent;
        border-color: currentColor;
        border-radius: 50%;
        width: 100%;
        height: 100%;
        background-color: transparent;
        animation: pure-material-progress-circular-pseudo 0.75s infinite linear alternate;
    }

    &:indeterminate::-ms-fill {
        animation-name: -ms-ring;
    }

    @keyframes pure-material-progress-circular {
        0% {
            transform: rotate(0deg);
        }
        12.5% {
            transform: rotate(180deg);
            animation-timing-function: linear;
        }
        25% {
            transform: rotate(630deg);
        }
        37.5% {
            transform: rotate(810deg);
            animation-timing-function: linear;
        }
        50% {
            transform: rotate(1260deg);
        }
        62.5% {
            transform: rotate(1440deg);
            animation-timing-function: linear;
        }
        75% {
            transform: rotate(1890deg);
        }
        87.5% {
            transform: rotate(2070deg);
            animation-timing-function: linear;
        }
        100% {
            transform: rotate(2520deg);
        }
    }

    @keyframes pure-material-progress-circular-pseudo {
        0% {
            transform: rotate(-30deg);
        }
        29.4% {
            border-left-color: transparent;
        }
        29.41% {
            border-left-color: currentColor;
        }
        64.7% {
            border-bottom-color: transparent;
        }
        64.71% {
            border-bottom-color: currentColor;
        }
        100% {
            border-left-color: currentColor;
            border-bottom-color: currentColor;
            transform: rotate(225deg);
        }
    }
`
export default () => {
    const { backdrop, backdropHide }= useSelector(state => { 
        return {
            backdrop: state.backdrop,
            backdropHide: state.backdropHide
        }
    })

    const relogin = useSyncExternalStore(subscribeRelogin, getRelogin)

    const classes = useStyles({ background: backdrop.background })

    // 재로그인 모달이 떠 있는 동안은 숨긴다 (로딩 화면이 모달을 덮지 않게)
    const show = backdrop.show && !backdropHide.action && !relogin.open

    // 닫히는 동안(사라지는 효과 0.2초)에도 열려 있을 때의 모양을 유지한다
    // (닫는 순간 quiet 값이 지워져서, 안 보이던 조용한 표시가 사라지면서 회색으로 번쩍였다)
    const quiet = useRef(false)
    if (show) quiet.current = backdrop.quiet

    return (
        <Backdrop className={`${classes.backdrop}${quiet.current ? ` ${classes.quiet}` : ''}`} open={show}>
           <Progress/>
          
            <TextStyled>
                {
                    backdrop.msg ? (
                        <Typography variant="h5" className={classes.typography}>{parseHtmlIntl(backdrop.msg)}</Typography>
                    ) : (
                        <Typography variant="body2">{parseHtmlIntl('Listovey')}</Typography>
                    )
                }
            </TextStyled>
        </Backdrop>
    )
}
